import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import arianaImage from "../../images/iserenify/iserenify_ariana_image_circle.JPEG";
import "./style.css";

const PHONE = "+40 743 222 996";
const PHONE_HREF = "tel:+40743222996";
const EMAIL = "ariana.henzel@yahoo.com";
const WHATSAPP_URL = "https://wa.me/40743222996";
const INSTAGRAM_URL =
  "https://www.instagram.com/ariana.henzel?igsh=MTN3MDJ0dTJ1am16Mg==";
const FACEBOOK_URL = "https://www.facebook.com/ariana.henzel1";

const Icon = {
  mail: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  phone: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  pin: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  send: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  ),
};

const initialForm = { name: "", email: "", subject: "", message: "" };

const NewContact = () => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const onChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    const name = form.name.trim();
    const email = form.email.trim();
    const message = form.message.trim();

    if (!name || !email || !message) {
      toast.error("Te rugăm să completezi numele, emailul și mesajul.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Adresa de email nu pare validă.");
      return;
    }

    setSubmitting(true);
    // Fall back to a mailto so the form works even without a backend handler.
    const subject = encodeURIComponent(
      form.subject.trim() || "Mesaj de pe theoilsbabe"
    );
    const body = encodeURIComponent(
      `Nume: ${name}\nEmail: ${email}\n\n${message}`
    );
    window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    toast.success("Mulțumim! Se deschide aplicația ta de email.");
    setForm(initialForm);
    setSubmitting(false);
  };

  return (
    <section className="new-contact" ref={sectionRef}>
      <div className="new-contact__inner">
        <div className="new-contact__header">
          <span className="new-contact__pre-title">CONTACT</span>
          <div className={`new-contact__phone-icon ${isVisible ? "new-contact__phone-icon--animate" : ""}`}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </div>
          <h2 className="new-contact__title">Hai să ne conectăm</h2>
          <p className="new-contact__subtitle">Primul pas spre echilibru începe aici</p>
          <p className="new-contact__desc">
            Uneori, tot ce avem nevoie este ghidarea potrivită și un spațiu în care să fim ascultați.
            <br />Fie că vrei să descoperi uleiurile esențiale potrivite pentru tine sau să participi la unul dintre evenimentele mele, sunt aici pentru tine.
          </p>
        </div>

        <div className="new-contact__grid">
          <aside className="new-contact__sidebar">
            <div className="new-contact__profile">
              <img
                src={arianaImage}
                alt="Ariana Henzel"
                className="new-contact__avatar"
                draggable="false"
              />
              <div>
                <p className="new-contact__name">Ariana Henzel</p>
                <p className="new-contact__role">
                  Consultant uleiuri esențiale
                </p>
              </div>
            </div>

            <ul className="new-contact__channels">
              <li>
                <a href={`mailto:${EMAIL}`} className="new-contact__channel">
                  <span className="new-contact__channel-icon">{Icon.mail}</span>
                  <span className="new-contact__channel-body">
                    <span className="new-contact__channel-label">Email</span>
                    <span className="new-contact__channel-value">{EMAIL}</span>
                  </span>
                </a>
              </li>
              <li>
                <a href={PHONE_HREF} className="new-contact__channel">
                  <span className="new-contact__channel-icon">{Icon.phone}</span>
                  <span className="new-contact__channel-body">
                    <span className="new-contact__channel-label">Telefon</span>
                    <span className="new-contact__channel-value">{PHONE}</span>
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="new-contact__channel"
                >
                  <span className="new-contact__channel-icon">
                    <i className="fi flaticon-new-whatsapp" />
                  </span>
                  <span className="new-contact__channel-body">
                    <span className="new-contact__channel-label">WhatsApp</span>
                    <span className="new-contact__channel-value">
                      Scrie-mi pe WhatsApp
                    </span>
                  </span>
                </a>
              </li>
              <li>
                <div className="new-contact__channel new-contact__channel--static">
                  <span className="new-contact__channel-icon">{Icon.pin}</span>
                  <span className="new-contact__channel-body">
                    <span className="new-contact__channel-label">Locație</span>
                    <span className="new-contact__channel-value">
                      Sibiu &amp; Cluj-Napoca, România
                    </span>
                  </span>
                </div>
              </li>
            </ul>

            <div className="new-contact__socials">
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="new-contact__social"
              >
                <i className="fi flaticon-facebook-app-symbol" />
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="new-contact__social"
              >
                <i className="fi flaticon-instagram" />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="new-contact__social"
              >
                <i className="fi flaticon-new-whatsapp" />
              </a>
            </div>
          </aside>

          {/* Right: form card with intro text inside */}
          <div className="new-contact__form-wrap">
            <form className="new-contact__form" onSubmit={onSubmit} noValidate>
              <p className="new-contact__form-lead">Completează formularul de mai jos sau scrie-mi direct pe WhatsApp. Îți voi răspunde în cel mai scurt timp.</p>
              <label className="new-contact__field">
                <span className="new-contact__label">Nume</span>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  placeholder="Numele tău"
                  autoComplete="name"
                  required
                />
              </label>

              <label className="new-contact__field">
                <span className="new-contact__label">Email</span>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="adresa@email.com"
                  autoComplete="email"
                  required
                />
              </label>

              <label className="new-contact__field">
                <span className="new-contact__label">Subiect</span>
                <input
                  type="text"
                  name="subject"
                  value={form.subject}
                  onChange={onChange}
                  placeholder="Ex.: Consultanță 1:1, Eveniment Cluj…"
                />
              </label>

              <label className="new-contact__field new-contact__field--textarea">
                <span className="new-contact__label">Mesaj</span>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  rows={6}
                  placeholder="Spune-mi pe scurt cu ce te pot ajuta."
                  required
                />
              </label>

              <button
                type="submit"
                className="new-contact__submit"
                disabled={submitting}
              >
                {submitting ? "Se trimite…" : "Trimite mesajul"}
                {Icon.send}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewContact;